import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'
import { useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { selectFormattedListingItems } from 'src/store/selectors/listings'
import Section from '../Section'

import styles from './HomeDetails.module.scss'

const propTypes = {
  className: PropTypes.string,
}

const defaultProps = {
  className: '',
}

const HomeDetails = ({ className }) => {
  const items = useSelector(selectFormattedListingItems)

  if (isEmpty(items)) {
    return null
  }

  return (
    <Section className={className}>
      <Section.Heading>
        <FormattedMessage
          id='HomeSearch.listingDetails.homeDetails'
          defaultMessage='Home Details'
        />
      </Section.Heading>
      <Section.Body>
        <ul className={styles.features}>
          {items.map(item => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </Section.Body>
    </Section>
  )
}

HomeDetails.propTypes = propTypes
HomeDetails.defaultProps = defaultProps

export default HomeDetails
